export default {
    updateAttendance: 'แก้ไขสถานะการเข้างาน',
    cancel: 'ยกเลิก',
    save: 'บันทึก',
    profile: 'ข้อมูลส่วนตัว',
    status: 'สถานะ',
    date: 'วันที่',
    checkinTime: 'เวลาเข้า',
    employeeId: 'รหัสพนักงาน',
    employeeFullname: 'ชื่อ - นามสกุล',
    email: 'อีเมล์',
    position: 'ตำแหน่ง',
    bureau: 'สำนักงาน / หน่วยงาน',
    activityLog: 'บันทึกกิจกรรม',
    thereIsNoActivityLog: 'ไม่มีบันทึกกิจกรรม',
    congratulation: 'ยินดีด้วย',
    errorMessage: 'เกิดข้อผิดพลาด',
    thisFieldIsRequired: 'กรุณากรอกข้อมูล',
    errorSelectTime: 'เวลาที่เลือกเกิดข้อผิดพลาด',
    activityMessage: 'อัปเดตเวลาเข้างาน : $checkinTime โดยผู้ใช้งาน : $userName'
}
